module.exports = __webpack_public_path__ + "img/rstep3t.2e88f505.png";